import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useEmptyStateActionStyles } from './empty-state-action-styles';

interface EmptyStateActionProps {
  className?: string;
  children: any;
}

export const EmptyStateAction = ({
  className,
  children,
}: EmptyStateActionProps) => {
  const classes = useEmptyStateActionStyles();

  return <div className={mergeClasses(className, classes.actionContainer)}>{children}</div>;
};
